export enum ESidePanelTabs {
  Layers = 'layers',
  Score = 'score',
  Navigator = 'navigator',
}

export enum PrintType {
  ExperimentInformation = 'EXPERIMENT_INFORMATION',
  ExperimentBarcode = 'EXPERIMENT_BARCODE',
}
